const resource = {
    resource_identifier_in_use: "L'identificatore API {{indicator}} è già in uso",
    cannot_delete_management_api: "Impossibile eliminare l'API di gestione di Logto.",
    cannot_modify_management_api: "Impossibile modificare l'API di gestione di Logto.",
};
export default Object.freeze(resource);
